import { Schedule } from 'store/schedules/interfaces';

export interface WorkScheduleCalendarProps {
  handleCloseModal: () => void;
  onScheduleEdit?: (schedule: Schedule) => void;
}

export enum WorkScheduleView {
  day = 'day',
  week = 'week',
}
